<section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">CHG-7  Register of Charges</strong>
      </span>
      <span style="float: right">
        <!-- <a routerLink="/chg7/add"> -->
          <button (click)="add()" class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button" [appHasPermission]="{'Url': '/register/chg7List/edit?goveva=true&email=', 'method':'put', 'menu': 'chg7List'}">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <span style="float:right">
          <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
            <span>
              <i class="fa fa-save"></i>&nbsp;Generate Output </span>
          </button>
        </span>
    </div>
    <!-- Date Filter  -->
    <section class="card search-box">
      <div class="card-header"(click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i
            class="fa fa-filter" aria-hidden="true"></i></span> </div>
      <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-md-3">
                <label>Charge ID</label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  <!-- <label>Nature of Documents Inspected </label> -->
                  <input type="text" class="form-control" [(ngModel)]="chargeId">
                </div>
              </div>
              <div class="col-md-3">
                <label>Name of the Charge Holder</label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  <!-- <label>Nature of Documents Inspected </label> -->
                  <input type="text" class="form-control" [(ngModel)]="chargeHolderName">
                </div>
              </div>
  
  
  
              <div class="col-md-3">
                <!-- <label>Date of satisfaction</label> -->
                <!-- <label>From</label> -->
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                  From :&nbsp;
                  <input id="dateOfSatisfaction" class="form-control" [minDate]="futureToDate"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfSatisfaction" ngbDatepicker
                    #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfSatisfaction">
                  <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                
                </div>
              </div>
  
  
              <div class="col-md-3">
                <!-- <label>Date of creation of charge</label> -->
                <!-- <label>To</label> -->
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                
                   To :&nbsp;
                  <input id="dateOfCreation" class="form-control" [minDate]="futureToDate"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfCreation" ngbDatepicker
                  #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfCreation">
                <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                </div>
              </div>
  
  
  
  
  
  
              <div class="col-md-4 col-sm-6 col-xs-12">
                <label>&nbsp;&nbsp;&nbsp;</label>
                <div class="input-group">
                  <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>&nbsp;Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                    (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Date filter End -->
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptionsOfChargeMaster" [dtTrigger]="dtTriggerChargeMaster"
                class="table table-hover compact cell-border nowrap stripe" id="chargeMasterTable"
                style="cursor: pointer;">
                <thead>
                  <tr>
                    <th>Charge ID</th>
                    <th>Date of <br>Registration <br>Created Charge</th>
                    <th style="display: none;">Date of Registration Created Charge</th>
                    <th>Amount secured <br>by the charge</th>
                    <th>Date of <br>Registration <br>Modified Charge</th>
                    <th style="display: none;">Date of Registration Modified Charge</th>
                    <th>Amount charged <br>after Modification</th>
                    <th>Satisfaction <br>Registration <br>Date</th>
                    <th style="display: none;">Satisfaction Registration Date</th>
                    <th>Date of <br>satisfaction</th>
                    <th style="display: none;">Date of satisfaction</th>
                    <th>Date of <br>creation <br>of charge</th>
                    <th style="display: none;">Date of creation <br>of charge</th>
                    <th class="actionclass">Action</th>
                  </tr>
                </thead>
  
                <tbody>
                  <tr *ngFor="let director of registerDirectorList">
                    <td>{{director.chargeId}}</td>
  
                    <td>
                      <span style="display: none">{{director.dateOfRegistration | date :"yMMdd"}}</span>
                      {{director.dateOfRegistration | date : "dd-MM-y"}}
                    </td>
                    <td style="display: none"> {{director.dateOfRegistration | date : "dd-MM-y"}} </td>
  
                    <td><span *ngIf="director">{{director.amountSecured}}</span></td>
  
                    <td>
                      <span *ngIf="director.modification">
                        <span style="display: none">{{director.modification.dateOfRegModification | date :"yMMdd"}}</span>
                        {{director.modification.dateOfRegModification | date : "dd-MM-y"}}
                      </span>
                    </td>
                    <td style="display: none">
                      <span *ngIf="director.modification">
                        {{director.modification.dateOfRegModification | date : "dd-MM-y"}}
                      </span>
                    </td>
  
                    <td>
                      <span *ngIf="director.modification">
                        {{director.modification.amountOfCharge}}</span></td>
  
                    <td>
                      <span *ngIf="director.satisfaction">
                        <span style="display: none">{{director.satisfaction.dateOfRegSatisfaction | date :"yMMdd"}}</span>
                        {{director.satisfaction.dateOfRegSatisfaction | date : "dd-MM-y"}}
                      </span>
                    </td>
                    <td style="display: none">
                      <span *ngIf="director.satisfaction">
                        {{director.satisfaction.dateOfRegSatisfaction | date : "dd-MM-y"}}
                      </span>
                    </td>
  
                    <td>
                      <span *ngIf="director.satisfaction">
                        <span style="display: none">{{director.satisfaction.dateOfSatisfaction | date :"yMMdd"}}</span>
                        {{director.satisfaction.dateOfSatisfaction | date : "dd-MM-y"}}
                      </span>
                    </td>
                    <td style="display: none">
                      <span *ngIf="director.satisfaction">
                        {{director.satisfaction.dateOfSatisfaction | date : "dd-MM-y"}}
                      </span>
                    </td>
  
                    <td>
                      <span style="display: none">{{director.dateOfCreation | date :"yMMdd"}}</span>
                      {{director.dateOfCreation | date : "dd-MM-y"}}
                    </td>
                    <td style="display: none"> {{director.dateOfCreation | date : "dd-MM-y"}} </td>
  
                    <td style='white-space: nowrap'>
                      <div class="input-group">
                        <button type="button" (click)="editChargedetail(director._id)" class="btn-sm btn btn-warning" [appHasPermission]="{'Url': '/register/chg7List/edit?goveva=true&email=', 'method':'put', 'menu': 'chg7List'}">
                          <span class="fa fa-pencil"></span>
                        </button>
                        &nbsp;&nbsp;
                        <button type="button" class="btn-sm btn btn-danger" delete-meeting="5cee33d225242e023acfb2d4" [appHasPermission]="{'Url': '/register/chg7List/edit?goveva=true&email=', 'method':'put', 'menu': 'chg7List'}"
                          (click)="confirmDelete(director._id)">
                          <span class="icmn-bin"></span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete charge master details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deleteChargeMasterdetail()">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <app-alert></app-alert>